<template>
  <section-wrapper>
    <div class="olympic active">
      <section class="olympic__header">
        <div class="olympic__header__text">
          <h1 class="text-danger">МЕЖДУНАРОДНАЯ ОНЛАЙН-ОЛИМПИАДА</h1>
          <h1 class="text-dark mb-2">Для студентов и молодежи</h1>
          <h1 class="mt-2 content_60">«КАДРЫ ДЛЯ ЭКСПОРТА»</h1>
        </div>
        <div class="d-none d-lg-block olympic__header__img">
          <img title="МЕЖДУНАРОДНАЯ ОНЛАЙН-ОЛИМПИАДА" src="/pic/owl.png" />
        </div>
      </section>
      <section class="olympic__text mb-5">
        <link-target link="/forms/olympics">РЕГИСТРАЦИЯ</link-target>
        <p class="content_22 mt-2">На Олимпиаду зарегистрировано более 150 участников, включая студентов из России, Беларуси и Кыргызстана.</p>
      </section>
      <section class="olympic__text mb-5">
        <h1 class="text-dark mb-2">Об Олимпиаде</h1>
        <p class="content_22 mb-2"><b>Олимпиада «Кадры для экспорта»</b> - это образовательное соревнование, которое помогает талантливой молодежи проявить себя в сфере внешнеэкономической деятельности.</p>
        <p class="content_22 mb-2">Участники смогут не только продемонстрировать свои знания и навыки, но и получить поддержку для дальнейшего профессионального развития!</p>
      </section>
      <section class="olympic__text mb-2">
        <div class="animated-container">
          <h1 class="text-dark mb-2">Кто может участвовать?</h1>
          <grid3-underline :items="[
              {title: 'Студенты бакалавриата', text: 'студенты старших курсов (4 курс бакалавриата, 5 курс специалитета)'},
              {title: 'Студенты магистратуры', text: 'студенты 1 и 2 курса магистратуры'},
              {title: 'Молодежь', text: 'выпускники ВУЗов до 35 лет'}
          ]" />
        </div>
      </section>
      <section class="olympic__text mb-2">
        <h1 class="text-dark mb-2">Расписание Олимпиады</h1>
        <schedule :steps="steps" />
      </section>
      <section class="olympic__text mb-2">
        <h1 class="text-dark mb-2">Возможности участника</h1>
        <p class="content_22 mt-2">Проверив свои знания, участник сможет получить обратную связь от экспертов в области внешнеэкономической деятельности, найти единомышленников из вузов не только своей страны, получить ценные артефакты Олимпиадника, среди которых:</p>

        <grid3-underline :items="[
              {title: 'Сертификат участника', text: 'Получат все , кто прошел все 3 этапа Олимпиады'},
              {title: 'Скидки на обучение', text: '99% скидку получат 5 призеров, 50% скидку получат все участники'},
              {title: 'Фирменный мерч', text: 'Розыгрыш среди участников Олимпиады'}
          ]" />
        <h1 class="text-dark mb-2">Задания Олимпиады</h1>
        <p class="content_22 mt-2">Участник Олимпиады попадет в игровую вселенную обычного работника отдела по экспорту крупной российский компании. Задачей будет подготовить и экспортировать продукт решая тестовые и кейсовые задания.</p>
        <p class="content_22 mt-2">Задания могут включать в себя следующие темы:</p>
        <ul>
          <li class="content_22">Логистика и таможня</li>
          <li class="content_22">Маркетинг и переговоры</li>
          <li class="content_22">Анализ рынка</li>
          <li class="content_22">Финансовые расчеты экспортной сделки</li>
        </ul>
        <p class="content_22 mt-2">Тестовые и кейсовые задания разработаны опытными тренерами и экспертами в сфере внешнеэкономической деятельности и проверены на действующих и потенциальных экспортерах.</p>
        <link-target link="/forms/olympics">РЕГИСТРАЦИЯ</link-target>
      </section>
    </div>
  </section-wrapper>
</template>

<script>
import SectionWrapper from "@/components/SectionWrapper.vue";
import Schedule from "@/components/Schedule.vue";
import Grid3Underline from "@/components/Grid3Underline.vue";
import LinkTarget from "@/components/LinkTarget.vue";

export default {
  name: "Olympics",
  components: {LinkTarget, Grid3Underline, Schedule, SectionWrapper},
  data() {
    return {
      steps: [
        {title: '1 ШАГ: ЗАРЕГИСТРИРОВАТЬСЯ НА ОЛИМПИАДУ', text: 'Регистрация происходит на странице Олимпиады на сайте exportedu.ru <span class=\'text-danger\'>8-19 ноября</span>'},
        {title: '2 ШАГ: РЕШИТЬ ЗАДАНИЯ ОЛИМПИАДЫ', text: "  <ul>\n" +
              "    <li>1 этап Олимпиады: поиск зарубежного контрагента <span class=\"text-danger\">20-21 ноября</span></li>\n" +
              "    <li>2 этап Олимпиады: переговоры и заключение контракта <span class=\"text-danger\">22-23 ноября</span></li>\n" +
              "    <li>3 этап Олимпиады: организация экспортной поставки <span class=\"text-danger\">24-25 ноября</span></li>\n" +
              "  </ul>"},
        {title: '3 ШАГ: УЗНАТЬ СВОЙ РЕЗУЛЬТАТ', text: 'Объявление итогов Олимпиады на онлайн-трансляции <span class=\'text-danger\'>2 декабря</span>'}
      ]
    }
  },
  mounted() {
    this.$parent.init()
  }
}
</script>